import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={toggleTheme}
      className="p-2 rounded-lg transition-colors hover:bg-white/10 dark-theme:hover:bg-white/10 light-theme:hover:bg-black/10"
      data-testid="theme-toggle"
      title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      {theme === 'dark' ? (
        <Sun className="w-5 h-5 text-zinc-400 hover:text-yellow-400" />
      ) : (
        <Moon className="w-5 h-5 text-zinc-600 hover:text-vent-primary" />
      )}
    </motion.button>
  );
};

export default ThemeToggle;
